import { createStore } from 'vuex';

import transferKitAssistant from './modules/transferKitAssistant';

export default createStore({
    modules: {
        transferKitAssistant
    },
});
